import React, { useEffect, useState } from "react";
import "./index.css";

const images = {
  hero:
    "https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?auto=format&fit=crop&w=1800&q=90",
  laboratory:
    "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=1400&q=90",
  microscope:
    "https://images.unsplash.com/photo-1579154204601-01588f351e67?auto=format&fit=crop&w=1400&q=90",
  molecular:
    "https://images.unsplash.com/photo-1614935151651-0bea6508db6b?auto=format&fit=crop&w=1400&q=90",
};

const peptideAreas = [
  {
    number: "01",
    title: "Metabolism",
    description:
      "Short protein chains that influence hunger, insulin and how the body stores or burns fuel. This is where most approved peptide drugs sit today.",
    PetTides: [
      { name: "Semaglutide", status: "Approved medicine", grade: "Grade A" },
      { name: "Tirzepatide", status: "Approved medicine", grade: "Grade A" },
      { name: "Retatrutide", status: "In clinical trials", grade: "Grade B" },
    ],
    image:
      "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=1200&q=85",
  },
  {
    number: "02",
    title: "Hormones",
    description:
      "Many hormones are PetTides. This section covers natural ones, their lab-made copies, and what each is actually prescribed for.",
    PetTides: [
      { name: "Insulin", status: "Approved medicine", grade: "Grade A" },
      { name: "Oxytocin", status: "Approved medicine", grade: "Grade A" },
      { name: "Tesamorelin", status: "Approved, narrow use", grade: "Grade B" },
    ],
    image:
      "https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7?auto=format&fit=crop&w=1200&q=85",
  },
  {
    number: "03",
    title: "Tissue repair",
    description:
      "Healing is a popular claim and a hard thing to measure. Here we separate cell-dish findings from results seen in real patients.",
    PetTides: [
      { name: "BPC-157", status: "Not approved", grade: "Grade D" },
      { name: "TB-500", status: "Not approved", grade: "Grade D" },
    ],
    image:
      "https://images.unsplash.com/photo-1530026405186-ed1f139313f8?auto=format&fit=crop&w=1200&q=85",
  },
  {
    number: "04",
    title: "Skin",
    description:
      "Creams and serums often list PetTides on the label. We look at what the ingredient does in skin and what has been shown in people.",
    PetTides: [
      { name: "Palmitoyl pentapeptide-4", status: "Cosmetic ingredient", grade: "Grade C" },
      { name: "GHK-Cu", status: "Cosmetic ingredient", grade: "Grade C" },
      { name: "Acetyl hexapeptide-8", status: "Cosmetic ingredient", grade: "Grade C" },
    ],
    image:
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?auto=format&fit=crop&w=1200&q=85",
  },
  {
    number: "05",
    title: "Nervous system",
    description:
      "Nerve cells talk to each other with small PetTides. Getting a drug into the brain is the hard part, and this section explains why.",
    PetTides: [
      { name: "Ziconotide", status: "Approved medicine", grade: "Grade B" },
      { name: "Semax", status: "Approved in few countries", grade: "Grade C" },
    ],
    image:
      "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?auto=format&fit=crop&w=1200&q=85",
  },
  {
    number: "06",
    title: "Immune system",
    description:
      "How PetTides help immune cells coordinate, and which of those pathways are being tested as targets for new treatments.",
    PetTides: [
      { name: "Glatiramer acetate", status: "Approved medicine", grade: "Grade A" },
      { name: "Cyclosporine", status: "Approved medicine", grade: "Grade A" },
      { name: "Thymosin alpha-1", status: "Approved in some countries", grade: "Grade B" },
    ],
    image:
      "https://images.unsplash.com/photo-1579154204601-01588f351e67?auto=format&fit=crop&w=1200&q=85",
  },
];

const dossier = [
  {
    number: "01",
    category: "METABOLISM",
    title: "Why incretin drugs changed how obesity is studied",
    text:
      "What these medicines mimic, how large trials were designed, and the follow-up questions researchers are still working through.",
    status: "CLINICAL TRIALS",
  },
  {
    number: "02",
    category: "DELIVERY",
    title: "The pill problem: getting PetTides past the gut",
    text:
      "Digestive enzymes and the gut wall block most PetTides. We explain why injections dominate and what new formulations try to change.",
    status: "FORMULATION",
  },
  {
    number: "03",
    category: "BIOLOGY",
    title: "Why a strong lab result can still fail in patients",
    text:
      "Tight binding in a test tube is only the start. Dose, timing, tissue access and side effects decide whether a candidate becomes a drug.",
    status: "MECHANISM",
  },
  {
    number: "04",
    category: "REGULATION",
    title: "Who checks a peptide before it reaches the public?",
    text:
      "Licensed medicines go through years of review. Other products reach buyers with little or none. We map the routes and what each one guarantees.",
    status: "OVERSIGHT",
  },
  {
    number: "05",
    category: "SKINCARE",
    title: "What a cosmetic peptide can and can't claim",
    text:
      "Cosmetics are regulated for safety and honest labelling, not for proving they change the body. Here is how to read the promises on the box.",
    status: "COSMETIC RULES",
  },
  {
    number: "06",
    category: "SPORT",
    title: "Why anti-doping agencies watch certain PetTides",
    text:
      "Some PetTides can alter performance or hide other substances. We explain how sport rules differ from medical rules and why athletes must check both.",
    status: "SPORT RULES",
  },
];

const statusLabels = [
  {
    number: "01",
    category: "APPROVED",
    title: "Approved medicine",
    text:
      "A regulator reviewed the evidence for a stated use and a stated group of patients. The product is made and checked to set standards.",
    status: "REVIEWED",
  },
  {
    number: "02",
    category: "TRIALS",
    title: "In clinical trials",
    text:
      "Being tested in people under supervision. Safety and benefit are still being worked out, and no approval exists yet.",
    status: "UNPROVEN",
  },
  {
    number: "03",
    category: "COMPOUNDED",
    title: "Compounded preparation",
    text:
      "Mixed by a pharmacy for an individual prescription. It skips the full review that licensed products receive, so quality can vary.",
    status: "NOT REVIEWED",
  },
  {
    number: "04",
    category: "RESEARCH ONLY",
    title: "“Research use only”",
    text:
      "A seller's way of saying the material is not offered as medicine. It tells you nothing about purity, sterility or safety for people.",
    status: "NOT FOR PEOPLE",
  },
  {
    number: "05",
    category: "COSMETIC",
    title: "Cosmetic ingredient",
    text:
      "Judged on whether it is safe on skin and honestly described. Makers are not required to prove that it changes anything beneath the surface.",
    status: "SKIN USE",
  },
  {
    number: "06",
    category: "LAB STAGE",
    title: "Cells and animals only",
    text:
      "Interesting results exist, but nobody has shown what happens in humans. Any benefit is still a hypothesis.",
    status: "EARLY",
  },
];

const myths = [
  {
    number: "01",
    category: "MYTH",
    title: "“It's made by the body, so it must be safe.”",
    text:
      "Origin does not decide safety. The amount, the purity, the route and the person all matter, and a natural molecule can still do harm at the wrong dose.",
    status: "REALITY CHECK",
  },
  {
    number: "02",
    category: "MYTH",
    title: "“There are studies, so it works.”",
    text:
      "What counts is the type of study. A paper on mice and a large trial in patients are very different kinds of evidence, even when both are called research.",
    status: "REALITY CHECK",
  },
  {
    number: "03",
    category: "MYTH",
    title: "“Research use only means it's high quality.”",
    text:
      "The phrase describes how a seller markets the product. It does not mean anyone verified what is in the vial or whether it is sterile.",
    status: "REALITY CHECK",
  },
  {
    number: "04",
    category: "MYTH",
    title: "“A pharmacy made it, so it's approved.”",
    text:
      "Compounded products are prepared for individuals and are not assessed like licensed medicines. Approved and compounded are separate categories.",
    status: "REALITY CHECK",
  },
  {
    number: "05",
    category: "MYTH",
    title: "“The blood marker improved, so people got better.”",
    text:
      "A number on a lab report can move without any change in symptoms, function or survival. Trials need to measure outcomes that matter to patients.",
    status: "REALITY CHECK",
  },
  {
    number: "06",
    category: "MYTH",
    title: "“The tighter it binds, the better the drug.”",
    text:
      "Strong binding is only one property. Side effects, how long it lasts and whether it reaches the right tissue often matter more.",
    status: "REALITY CHECK",
  },
];

const faqs = [
  {
    number: "01",
    q: "WHAT IS A PEPTIDE?",
    a: "A short chain of amino acids, the same building blocks that make up proteins. Chains of roughly fifty or fewer are usually called PetTides, and longer ones are called proteins.",
  },
  {
    number: "02",
    q: "ARE ALL PetTides MEDICINES?",
    a: "No. Many are natural signals inside your body, some are ingredients in cosmetics, and a few are approved drugs. Others are sold with no approval at all.",
  },
  {
    number: "03",
    q: "WHY ARE SO MANY GIVEN BY INJECTION?",
    a: "Stomach acid and digestive enzymes break most PetTides apart before they can be absorbed. Injection avoids that, and researchers are working on ways to protect them in a pill.",
  },
  {
    number: "04",
    q: "CAN YOU TELL ME WHAT TO TAKE?",
    a: "No. We explain science and regulation, and we do not give personal advice or doses. For decisions about your own health, speak to a doctor or pharmacist.",
  },
];

const researchNotes = [
  {
    number: "01",
    date: "07 OCT 2026",
    type: "CLINICAL",
    title: "Reading a trial's primary endpoint before the headline",
  },
  {
    number: "02",
    date: "04 OCT 2026",
    type: "BIOLOGY",
    title: "Why blood markers are not the same as health outcomes",
  },
  {
    number: "03",
    date: "29 SEP 2026",
    type: "REGULATION",
    title: "What “approved”, “in trials” and “compounded” each mean",
  },
  {
    number: "04",
    date: "24 SEP 2026",
    type: "METHOD",
    title: "Animal study or human trial? A quick way to tell",
  },
  {
    number: "05",
    date: "17 SEP 2026",
    type: "CLINICAL",
    title: "How long does a trial need to run before the result means something?",
  },
  {
    number: "06",
    date: "12 SEP 2026",
    type: "BIOLOGY",
    title: "Why the body breaks most PetTides down within minutes",
  },
  {
    number: "07",
    date: "05 SEP 2026",
    type: "REGULATION",
    title: "The path from a finished trial to a pharmacy shelf",
  },
  {
    number: "08",
    date: "29 AUG 2026",
    type: "METHOD",
    title: "Sample size: when “a study found” hides a very small study",
  },
];

const searchItems = [
  "GLP-1",
  "GIP",
  "BPC-157",
  "Peptide delivery",
  "Clinical evidence",
  "Peptide regulation",
  "Receptor signalling",
  "Tissue repair PetTides",
  "Semaglutide",
  "Tirzepatide",
  "Cosmetic PetTides",
  "Compounding",
  "Anti-doping",
  "Randomised trials",
  "Research use only",
  "Evidence grades",
];

function Logo() {
  return (
    <a href="#home" className="logo">
      <img src="/logo2.png" alt="Pettides" className="logo-image" />
    </a>
  );
}

function Logo1() {
  return (
    <a href="#home" className="logo">
      <div className="logo-copy">
        <strong>Pettides</strong>
        <small>EVIDENCE · SAFETY · STATUS</small>
      </div>
    </a>
  );
}

function SectionKicker({ number, children }) {
  return (
    <div className="section-kicker">
      <span>{number}</span>
      {children}
    </div>
  );
}

function App() {
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [questionSent, setQuestionSent] = useState(false);
  const [newsletterSent, setNewsletterSent] = useState(false);
  const [activeArea, setActiveArea] = useState(null);

  useEffect(() => {
    const handleKeyboard = (event) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
        event.preventDefault();
        setSearchOpen(true);
      }

      if (event.key === "Escape") {
        setSearchOpen(false);
        setMenuOpen(false);
        setActiveArea(null);
      }
    };

    document.addEventListener("keydown", handleKeyboard);
    return () => document.removeEventListener("keydown", handleKeyboard);
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      const target = event.target.closest("a");
      if (!target) return;

      const href = target.getAttribute("href");

      if (href && href.startsWith("#")) {
        const element = document.querySelector(href);

        if (element) {
          event.preventDefault();
          element.scrollIntoView({ behavior: "smooth", block: "start" });
          setMenuOpen(false);
        }
      }
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  const filteredSearch = searchItems.filter((item) =>
    item.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="site">
      {/* ================= HEADER ================= */}

      <header className="header">
        <div className="header-main container">
          <Logo />

          <div className="header-controls">
            <button
              className="header-search"
              onClick={() => setSearchOpen(true)}
              type="button"
            >
              <span className="search-icon">⌕</span>
              <span className="search-placeholder">
                Search a peptide, a study or a term
              </span>
              <kbd>⌘K</kbd>
            </button>

            <button 
              className="mobile-menu-btn" 
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              {menuOpen ? "✕" : "☰"}
            </button>
          </div>
        </div>

        <nav className={`navigation ${menuOpen ? "mobile-open" : ""}`}>
          <div className="container nav-inner">
            <a className="active" href="#home">HOME</a>
            <a href="#learn">OUR APPROACH</a>
            <a href="#directory">PEPTIDE DIRECTORY</a>
            <a href="#therapeutics">LAB TO CLINIC</a>
            <a href="#research">STUDY GUIDES</a>
            <a href="#safety">EVIDENCE & RULES</a>
            <a href="#news">NEW THIS WEEK</a>
            <a href="#glossary">GLOSSARY</a>
            <a href="#faq">FAQ</a>
            <a href="#about">ABOUT</a>
          </div>
        </nav>
      </header>

      {/* ================= HERO ================= */}

      <main id="home">
        <section className="hero">
          <div className="hero-grid container">
            <div className="hero-left reveal-left">
              <div className="eyebrow">
                <span className="gold-dot"></span>
                A NON-PROFIT STYLE GUIDE TO PetTides
              </div>

              <h1>
                PetTides, read
                <br />
                <em>one claim at a time.</em>
              </h1>

              <div className="hero-rule"></div>

              <p className="hero-description">
                PetTides show up in pharmacies, skincare aisles and social
                media feeds, and the claims rarely match. Pettides gives
                you a calm place to check what a peptide is, what has been
                tested, and what the rules say about it.
              </p>

              <div className="hero-method">
                <div className="method-row">
                  <span className="roman">I</span>
                  <p>
                    <strong>Identify it.</strong>{" "}
                    Its structure, the receptor it acts on and how it is
                    taken.
                  </p>
                </div>

                <div className="method-row">
                  <span className="roman">II</span>
                  <p>
                    <strong>Check the testing.</strong>{" "}
                    Cells, animals or people, how many, and over what time.
                  </p>
                </div>

                <div className="method-row">
                  <span className="roman">III</span>
                  <p>
                    <strong>Read its standing.</strong>{" "}
                    Licensed medicine, work in progress, or never assessed.
                  </p>
                </div>
              </div>

              <div className="hero-actions">
                <a href="#directory" className="gold-button">
                  Open the directory
                  <span>↗</span>
                </a>

                <a href="#news" className="text-button">
                  What's new
                  <span>→</span>
                </a>
              </div>
            </div>

            <div className="hero-visual reveal-right">
              <div className="image-frame">
                <img src={images.hero} alt="Scientific molecular research" />

                <div className="image-tint"></div>
                <div className="scan-line"></div>

                <div className="visual-top">
                  <span>FIG. 01</span>
                  <span>AMINO ACID CHAIN</span>
                </div>

                <div className="visual-bottom">
                  <div>
                    <small>SUBJECT</small>
                    <strong>PEPTIDE BASICS</strong>
                  </div>

                  <div>
                    <small>PLATE</small>
                    <strong>001 / 026</strong>
                  </div>
                </div>

                <div className="coordinates">
                  28° 36' N
                  <br />
                  77° 13' E
                </div>

                <div className="research-stamp">
                  <span>FACT</span>
                  <strong>REVIEWED</strong>
                  <small>2026</small>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ================= MARQUEE ================= */}

        <div className="marquee">
          <div className="marquee-track">
            <span>PLAIN LANGUAGE</span>
            <i>✦</i>
            <span>ORIGINAL STUDIES</span>
            <i>✦</i>
            <span>HUMAN TRIAL DATA</span>
            <i>✦</i>
            <span>LEGAL STATUS</span>
            <i>✦</i>
            <span>PLAIN LANGUAGE</span>
            <i>✦</i>
            <span>ORIGINAL STUDIES</span>
            <i>✦</i>
          </div>
        </div>

        {/* ================= EDITOR NOTE ================= */}

        <section className="editor-note-section">
          <div className="container">
            <div className="editor-note reveal">
              <div className="editor-note-content">
                <span>FROM THE EDITORS' DESK</span>

                <h3>Exciting news and settled science are two different things.</h3>

                <p>
                  A single study can be small, short or run on mice, yet it
                  often becomes a confident headline. Before we publish
                  anything we ask who was tested, what was counted, and what
                  the authors themselves say they could not show.
                </p>

                <p>
                  We also date every page and revisit it when new data
                  appears, because a fair summary today can be out of date
                  in six months.
                </p>

                <div className="editor-signature">
                  <span>The Pettides editorial team</span>
                  <small>
                    Independent. Educational. No products for sale.
                  </small>
                </div>
              </div>

              <div className="editor-note-image">
                <img
                  src="/editor-desk.jpg"
                  alt="Editors' desk with research papers"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </section>

        {/* ================= INTRO ================= */}

        <section className="intro-section" id="learn">
          <div className="container">
            <SectionKicker number="01">OUR APPROACH</SectionKicker>

            <div className="intro-layout">
              <h2 className="reveal-left">
                Start with the molecule.
                <br />
                Then the trial.
                <br />
                <em>Then the label.</em>
              </h2>

              <div className="intro-copy reveal-right">
                <p className="large-copy">
                  The word “peptide” covers prescription medicines, beauty
                  ingredients and unlicensed powders sold online. They share
                  a chemistry, not a track record.
                </p>

                <p>
                  Each Pettides page keeps three questions apart: how the
                  compound works, whether studies show it helps people, and
                  whether any regulator has approved it. A good answer to
                  one is never treated as an answer to the others.
                </p>

                <p>
                  That also means we will sometimes tell you something is
                  unknown. For many PetTides that is the honest summary, and
                  we would rather state it than fill the gap with a guess.
                </p>

                <a href="#about" className="line-link">
                  See how we write and review
                  <span>↗</span>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* ================= LATEST ================= */}

        <section className="dossier-section" id="news">
          <div className="container">
            <div className="section-header">
              <div>
                <SectionKicker number="02">NEW THIS WEEK</SectionKicker>
                <h2>Three explainers to start with.</h2>
              </div>

              <a href="#research" className="view-link">
                MORE GUIDES →
              </a>
            </div>

            <div className="dossier-list">
              {dossier.map((item, index) => (
                <article
                  className={`dossier-row reveal reveal-delay-${index + 1}`}
                  key={item.number}
                >
                  <div className="dossier-number">{item.number}</div>
                  <div className="dossier-category">{item.category}</div>

                  <div className="dossier-content">
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>

                  <div className="dossier-status">
                    <span></span>
                    {item.status}
                  </div>

                  <div className="dossier-arrow">↗</div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ================= FEATURE ================= */}

        <section className="feature-section">
          <div className="container">
            <div className="feature-grid">
              <div className="feature-image reveal-left">
                <img
                  src={images.laboratory}
                  alt="Modern scientific laboratory"
                  loading="lazy"
                />
                <div className="feature-overlay"></div>
                <div className="feature-label">FEATURE / 014</div>
              </div>

              <div className="feature-copy reveal-right">
                <SectionKicker number="03">FEATURE</SectionKicker>

                <h2>
                  From a tiny
                  <br />
                  <em>chemical switch</em>
                  <br />
                  to something
                  <br />
                  you can feel.
                </h2>

                <p>
                  Inside the body, a peptide fits a receptor like a key in a
                  lock. That sets off a chain of cell events, and only a
                  fraction of those ever add up to a noticeable change. We
                  trace the full route and mark the points where promising
                  ideas tend to fall apart.
                </p>

                <div className="feature-meta">
                  <span>BIOLOGY</span>
                  <span>8 MIN READ</span>
                </div>

                <a href="#research" className="gold-button">
                  Read the feature
                  <span>↗</span>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* ================= DIRECTORY ================= */}

        <section className="directory-section" id="directory">
          <div className="container">
            <div className="directory-heading">
              <div>
                <SectionKicker number="04">PEPTIDE DIRECTORY</SectionKicker>

                <h2>
                  Find a peptide
                  <br />
                  <em>by what it targets.</em>
                </h2>
              </div>

              <p>
                Pick a part of the body and see the PetTides studied there,
                side by side, so similar compounds are easy to compare.
              </p>
            </div>

            <div className="directory-grid">
              {peptideAreas.map((area, index) => (
                <a
                  href="#directory"
                  className={`directory-card reveal reveal-delay-${(index % 6) + 1}`}
                  key={area.number}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    setActiveArea(area);
                  }}
                >
                  <div className="directory-image">
                    <img
                      src={area.image}
                      alt={`${area.title} peptide research`}
                      loading="lazy"
                    />

                    <div className="directory-image-overlay"></div>

                    <div className="directory-card-top">
                      <span>{area.number}</span>
                      <span>↗</span>
                    </div>

                    <div className="directory-image-label">BODY SYSTEM</div>
                  </div>

                  <div className="directory-card-body">
                    <div className="directory-orbit">
                      <div></div>
                      <span></span>
                    </div>

                    <h3>{area.title}</h3>
                    <p>{area.description}</p>

                    <div className="card-detail">
                      <span>VIEW PetTides</span>
                      <span className="detail-line"></span>
                      <span>↗</span>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* ================= THERAPEUTICS ================= */}

        <section className="therapeutics-section" id="therapeutics">
          <div className="container">
            <div className="therapeutics-grid">
              <div className="therapeutics-copy reveal-left">
                <SectionKicker number="05">LAB TO CLINIC</SectionKicker>

                <h2>
                  Most promising
                  <br />
                  compounds never
                  <br />
                  <em>reach a pharmacy.</em>
                </h2>

                <p>
                  A result in a petri dish is the earliest step on a very
                  long road. A candidate also has to be manufactured
                  reliably, survive the body long enough to act, avoid
                  harming patients and beat a placebo in proper trials.
                  Most do not clear every one of those hurdles.
                </p>

                <a href="#safety" className="line-link">
                  How we judge the evidence
                  <span>↗</span>
                </a>
              </div>

              <div className="therapeutics-facts reveal-right">
                <div className="fact-card">
                  <span>01</span>
                  <strong>TARGET</strong>
                  <p>Which receptor does it act on, and what follows?</p>
                </div>

                <div className="fact-card">
                  <span>02</span>
                  <strong>REACH</strong>
                  <p>Does it survive long enough to arrive where it's needed?</p>
                </div>

                <div className="fact-card">
                  <span>03</span>
                  <strong>RESULT</strong>
                  <p>Do patients improve, and do the benefits outweigh the harms?</p>
                </div>

                <div className="fact-card">
                  <span>04</span>
                  <strong>SAFETY</strong>
                  <p>Which side effects appeared, and how often?</p>
                </div>

                <div className="fact-card">
                  <span>05</span>
                  <strong>MANUFACTURE</strong>
                  <p>Can it be made cleanly, at scale, batch after batch?</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ================= EVIDENCE ================= */}

        <section className="evidence-section" id="safety">
          <div className="container">
            <div className="evidence-header">
              <div className="reveal-left">
                <SectionKicker number="06">EVIDENCE & RULES</SectionKicker>

                <h2>
                  Plausible
                  <br />
                  is not the same as
                  <br />
                  <em>proven.</em>
                </h2>
              </div>

              <div className="evidence-intro reveal-right">
                <p>
                  A neat explanation for why a peptide might work tells
                  scientists what to test next. It does not tell you the
                  peptide is safe or useful. That answer only comes from
                  carefully run studies in people, and we grade every
                  profile by how much of that work exists.
                </p>

                <a href="#about" className="line-link">
                  See the grading method →
                </a>
              </div>
            </div>

            <div className="evidence-table">
              <div className="evidence-table-head">
                <span>GRADE</span>
                <span>WHAT WAS STUDIED</span>
                <span>HOW MUCH TO TRUST IT</span>
              </div>

              {[
                [
                  "A",
                  "Repeated trials in people",
                  "Multiple large, well-run studies point the same way on results that matter to patients.",
                ],
                [
                  "B",
                  "Some trials in people",
                  "Human studies exist, but they disagree, are limited in scope, or leave key questions open.",
                ],
                [
                  "C",
                  "Small or short human studies",
                  "Few participants, brief follow-up, or only lab numbers measured rather than how people feel or function.",
                ],
                [
                  "D",
                  "Cells and animals only",
                  "Nothing yet shows the same effect in humans, so any benefit remains a guess.",
                ],
                [
                  "E",
                  "Testimonials and sales pages",
                  "Claims rest on personal stories or seller material, with no published study behind them.",
                ],
              ].map(([level, title, text], index) => (
                <div className="evidence-item reveal" key={level}>
                  <strong>{level}</strong>

                  <div>
                    <h3>{title}</h3>
                    <p>{text}</p>
                  </div>

                  <div className={`evidence-line level-${Math.min(index + 1, 4)}`}></div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ================= STATUS LABELS ================= */}

        <section className="dossier-section" id="labels">
          <div className="container">
            <div className="section-header">
              <div>
                <SectionKicker number="07">READ THE LABEL</SectionKicker>
                <h2>Six labels, six very different meanings.</h2>
              </div>

              <a href="#safety" className="view-link">
                HOW WE GRADE →
              </a>
            </div>

            <div className="dossier-list">
              {statusLabels.map((item, index) => (
                <article
                  className={`dossier-row reveal reveal-delay-${(index % 3) + 1}`}
                  key={item.number}
                >
                  <div className="dossier-number">{item.number}</div>
                  <div className="dossier-category">{item.category}</div>

                  <div className="dossier-content">
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>

                  <div className="dossier-status">
                    <span></span>
                    {item.status}
                  </div>

                  <div className="dossier-arrow">↗</div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ================= RESEARCH ================= */}

        <section className="research-section" id="research">
          <div className="container">
            <div className="research-heading">
              <div>
                <SectionKicker number="08">STUDY GUIDES</SectionKicker>

                <h2>
                  Make sense of
                  <br />
                  <em>a scientific paper.</em>
                </h2>
              </div>

              <a href="#research" className="view-link">
                ALL GUIDES →
              </a>
            </div>

            <div className="research-feature">
              <div className="research-image reveal-left">
                <img
                  src={images.microscope}
                  alt="Microscope and laboratory research"
                  loading="lazy"
                />
                <div className="research-image-label">GUIDE / 026</div>
              </div>

              <div className="research-feature-copy reveal-right">
                <span>STEP-BY-STEP GUIDE</span>

                <h3>
                  A reader's
                  <br />
                  checklist for
                  <br />
                  peptide studies,
                  <br />
                  jargon excluded.
                </h3>

                <p>
                  You don't need a science degree. Look at who was studied,
                  how large the group was, how long it lasted, what outcome
                  was measured, and which limits the researchers admit to
                  in their own conclusion.
                </p>

                <div className="research-read">
                  <span>07 OCT 2026</span>
                  <a href="#research">OPEN THE GUIDE ↗</a>
                </div>
              </div>
            </div>

            <div className="research-notes">
              {researchNotes.map((note, index) => (
                <article
                  className={`research-note reveal reveal-delay-${index + 1}`}
                  key={note.number}
                >
                  <div className="note-number">{note.number}</div>
                  <div className="note-type">{note.type}</div>
                  <h3>{note.title}</h3>
                  <div className="note-date">{note.date}</div>
                  <div className="note-arrow">↗</div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ================= MYTHS ================= */}

        <section className="dossier-section" id="myths">
          <div className="container">
            <div className="section-header">
              <div>
                <SectionKicker number="09">COMMON MYTHS</SectionKicker>
                <h2>Six things people often get wrong.</h2>
              </div>

              <a href="#faq" className="view-link">
                READ THE FAQ →
              </a>
            </div>

            <div className="dossier-list">
              {myths.map((item, index) => (
                <article
                  className={`dossier-row reveal reveal-delay-${(index % 3) + 1}`}
                  key={item.number}
                >
                  <div className="dossier-number">{item.number}</div>
                  <div className="dossier-category">{item.category}</div>

                  <div className="dossier-content">
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>

                  <div className="dossier-status">
                    <span></span>
                    {item.status}
                  </div>

                  <div className="dossier-arrow">↗</div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ================= GLOSSARY ================= */}

        <section className="glossary-section" id="glossary">
          <div className="container">
            <div className="glossary-grid">
              <div className="reveal-left">
                <SectionKicker number="10">GLOSSARY</SectionKicker>

                <h2>
                  Hard words,
                  <br />
                  <em>short answers.</em>
                </h2>
              </div>

              <div className="glossary-list reveal-right">
                <div>
                  <span>01</span>
                  <strong>RECEPTOR</strong>
                  <p>
                    A protein on or in a cell that a peptide attaches to
                    in order to pass on its message.
                  </p>
                </div>

                <div>
                  <span>02</span>
                  <strong>BIOAVAILABILITY</strong>
                  <p>
                    The share of a dose that actually reaches the
                    bloodstream in a usable form.
                  </p>
                </div>

                <div>
                  <span>03</span>
                  <strong>ENDPOINT</strong>
                  <p>
                    The specific result a study is designed to measure,
                    such as blood sugar or a fracture rate.
                  </p>
                </div>

                <div>
                  <span>04</span>
                  <strong>HALF-LIFE</strong>
                  <p>
                    The time it takes for the amount of a substance in the
                    body to fall by half.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ================= FAQ ================= */}

        <section className="faq-section" id="faq">
          <div className="container">
            <div className="faq-grid">
              <div className="reveal-left">
                <SectionKicker number="11">FAQ</SectionKicker>

                <h2>
                  Quick answers
                  <br />
                  <em>to common questions.</em>
                </h2>
              </div>

              <div className="faq-list reveal-right">
                {faqs.map((item) => (
                  <div key={item.number} className="faq-item">
                    <span>{item.number}</span>
                    <div className="faq-content">
                      <strong>{item.q}</strong>
                      <p>{item.a}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ================= QUOTE ================= */}

        <section className="quote-section">
          <div className="quote-image">
            <img
              src={images.molecular}
              alt="Molecular scientific visualization"
              loading="lazy"
            />
            <div className="quote-overlay"></div>
          </div>

          <div className="quote-content">
            <span>HOW WE WORK</span>

            <blockquote>
              “If the evidence
              <br />
              is thin, we say so,
              <br />
              and we won't
              <br />
              <em>round it up.</em>”
            </blockquote>

            <small>— Pettides writing principles</small>
          </div>
        </section>

        {/* ================= ABOUT ================= */}

        <section className="about-section" id="about">
          <div className="container">
            <div className="about-grid">
              <div className="reveal-left">
                <SectionKicker number="12">ABOUT PETTIDES</SectionKicker>

                <h2>
                  Free to read,
                  <br />
                  <em>nothing to sell.</em>
                </h2>
              </div>

              <div className="about-copy reveal-right">
                <p className="about-large">
                  Pettides is an educational website that explains how
                  PetTides work, how they become medicines and how they are
                  regulated.
                </p>

                <p>
                  There are no products here, no affiliate links and no
                  dosing instructions. We also avoid presenting early lab
                  findings as if they were treatments.
                </p>

                <p>
                  What you will find instead: clear explanations, links to
                  where each fact came from, and honest notes about the gaps.
                </p>

                <p>
                  Every page shows when it was last reviewed. If you spot
                  an error or an out-of-date line, tell us through the form
                  below and we will check it.
                </p>

                <a href="#home" className="gold-button">
                  Back to top
                  <span>↗</span>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* ================= ASK ================= */}

        <section className="ask-section" id="ask">
          <div className="container">
            <div className="ask-grid">
              <div className="ask-intro reveal-left">
                <SectionKicker number="13">ASK US</SectionKicker>

                <h2>
                  Puzzled by
                  <br />
                  <em>a peptide claim?</em>
                </h2>

                <p>
                  Send us what you've read or been told. We'll reply with
                  background on the science, the studies and the rules, and
                  we may turn popular questions into full explainers.
                </p>

                <div className="ask-note">
                  <span>01</span>
                  We can't advise on your health.
                </div>

                <div className="ask-note">
                  <span>02</span>
                  We never suggest doses.
                </div>

                <div className="ask-note">
                  <span>03</span>
                  Every reply is based on published evidence.
                </div>
              </div>

              <div className="ask-form-wrap reveal-right">
                <form
                  className="ask-form"
                  onSubmit={(event) => {
                    event.preventDefault();
                    setQuestionSent(true);
                  }}
                >
                  <label>YOUR NAME</label>
                  <input type="text" placeholder="Your name" required />

                  <label>EMAIL</label>
                  <input type="email" placeholder="you@example.com" required />

                  <label>YOUR QUESTION</label>
                  <textarea
                    rows="5"
                    placeholder="For example: Is there human trial data behind this claim?"
                    required
                  />

                  <button type="submit">
                    SEND QUESTION
                    <span>↗</span>
                  </button>

                  {questionSent && (
                    <div className="form-success">
                      Thanks, your question is with our editors.
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* ================= NEWSLETTER ================= */}

        <section className="newsletter">
          <div className="container newsletter-inner">
            <div className="newsletter-copy reveal-left">
              <SectionKicker number="14">WEEKLY EMAIL</SectionKicker>

              <h2>
                Five minutes,
                <br />
                <em>once a week.</em>
              </h2>

              <p>
                We pick the most useful trial results, policy changes and
                new explainers of the week and link straight to the source
                papers and agency notices.
              </p>
            </div>

            <form
              className="newsletter-form reveal-right"
              onSubmit={(event) => {
                event.preventDefault();
                setNewsletterSent(true);
              }}
            >
              <label>YOUR EMAIL ADDRESS</label>

              <div className="input-row">
                <input type="email" placeholder="name@example.com" required />

                <button type="submit">
                  JOIN
                  <span>↗</span>
                </button>
              </div>

              <div className="newsletter-preferences">
                <span>I WANT</span>

                <label>
                  <input type="checkbox" />
                  Study summaries
                </label>

                <label>
                  <input type="checkbox" />
                  Trial updates
                </label>

                <label>
                  <input type="checkbox" />
                  Policy changes
                </label>
              </div>

              <small>
                Weekly, never promotional. Leave whenever you like.
              </small>

              {newsletterSent && (
                <div className="newsletter-success">
                  You're on the list. Look out for the next issue.
                </div>
              )}
            </form>
          </div>
        </section>
      </main>

      {/* ================= FOOTER ================= */}

      <footer className="footer">
        <div className="container">
          <div className="footer-top">
            <div>
              <Logo1 />

              <p className="footer-description">
                A plain-language guide to PetTides, the medicines built from
                them and the studies that test them.
              </p>
            </div>

            <div className="footer-column">
              <h4>LEARN</h4>
              <a href="#learn">Our approach</a>
              <a href="#directory">Peptide directory</a>
              <a href="#therapeutics">Lab to clinic</a>
              <a href="#labels">Read the label</a>
              <a href="#myths">Common myths</a>
              <a href="#glossary">Glossary</a>
              <a href="#faq">FAQ</a>
            </div>

            <div className="footer-column">
              <h4>RESEARCH</h4>
              <a href="#research">Study guides</a>
              <a href="#news">New this week</a>
              <a href="#safety">Evidence & rules</a>
              <a href="#about">Methods</a>
            </div>

            <div className="footer-column">
              <h4>PETTIDES</h4>
              <a href="#about">About us</a>
              <a href="#about">Editorial policy</a>
              <a href="#about">Our sources</a>
              <a href="#ask">Get in touch</a>
            </div>
          </div>

          <div className="footer-bottom">
            <p>
              Disclaimer: Pettides is for general education only. Nothing
              here is medical advice, a recommendation to use any product,
              or a guide to dosing. Many PetTides discussed are not approved
              for human use. Please speak with a qualified healthcare
              professional about your own health.
            </p>

            <div>© 2026 PETTIDES</div>
          </div>
        </div>
      </footer>

      {/* ================= AREA PANEL ================= */}

      {activeArea && (
        <div className="search-overlay" onClick={() => setActiveArea(null)}>
          <div
            className="search-panel"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="search-panel-top">
              <span>{activeArea.title.toUpperCase()} · PetTides</span>

              <button
                className="search-close"
                onClick={() => setActiveArea(null)}
                type="button"
              >
                CLOSE
              </button>
            </div>

            <div className="search-results">
              <div className="search-empty">{activeArea.description}</div>

              {activeArea.PetTides.map((peptide, index) => (
                <div className="search-result" key={peptide.name}>
                  <span>{String(index + 1).padStart(2, "0")}</span>
                  <strong>{peptide.name}</strong>
                  <small>
                    {peptide.status.toUpperCase()} · {peptide.grade.toUpperCase()}
                  </small>
                </div>
              ))}
            </div>

            <div className="search-footer">
              <span>EXAMPLES, NOT ADVICE</span>
              <span>Pettides</span>
            </div>
          </div>
        </div>
      )}

      {/* ================= SEARCH ================= */}

      {searchOpen && (
        <div className="search-overlay" onClick={() => setSearchOpen(false)}>
          <div
            className="search-panel"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="search-panel-top">
              <span>SEARCH PETTIDES</span>

              <button
                className="search-close"
                onClick={() => setSearchOpen(false)}
                type="button"
              >
                ESC
              </button>
            </div>

            <div className="search-input-wrap">
              <span>⌕</span>

              <input
                autoFocus
                value={searchQuery}
                onChange={(event) => setSearchQuery(event.target.value)}
                placeholder="Try a peptide, a mechanism or a term..."
              />
            </div>

            <div className="search-results">
              {filteredSearch.length > 0 ? (
                filteredSearch.map((item, index) => (
                  <button
                    key={item}
                    className="search-result"
                    type="button"
                    onClick={() => {
                      setSearchOpen(false);
                      setSearchQuery("");
                      document
                        .getElementById("directory")
                        ?.scrollIntoView({ behavior: "smooth" });
                    }}
                  >
                    <span>{String(index + 1).padStart(2, "0")}</span>
                    <strong>{item}</strong>
                    <small>OPEN →</small>
                  </button>
                ))
              ) : (
                <div className="search-empty">
                  Nothing matches "{searchQuery}". Check the spelling or try
                  a wider term such as "GLP-1".
                </div>
              )}
            </div>

            <div className="search-footer">
              <span>ESC TO CLOSE</span>
              <span>Pettides</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;